module.exports = __webpack_public_path__ + "media/img/files/file-1-6a9e16bf196d333e0949c2befdf6c60d.jpg";